// extracted by mini-css-extract-plugin
export default {"halfWidth":"ServiceGrid_halfWidth__k7t03","toolbarContainer":"ServiceGrid_toolbarContainer__Uc5kH"};